@use "../../../sass/variables/colors";
@use "../../../sass/mixins/font-family";

.ux-autosuggest-item {
  @include font-family.font(light);

  background-color: colors.$color-white;
  border-bottom: solid 1px colors.$color-gray-25;
  color: colors.$color-gray-copy;
  display: flex;

  &__image {
    background-color: colors.$color-gray-10;
    background-size: cover;
    height: 75px;
    width: 75px;
  }

  &__text-container {
    padding: 15px;
  }

  &--slim &__text-container {
    padding: 5px 15px;
  }

  &--slim:hover {
    background-color: colors.$color-gray-10;
  }

  &--slim {
    border-bottom: solid 1px colors.$color-gray-10;
  }

  &__highlight {
    color: colors.$color-green;
  }

  &__subline {
    text-transform: uppercase;
  }
}
